export default {
  namespaced: true,
  state: {
    loading: true,
    pagination: {
      current: null,
      total: null,
      data: [],
    },
    requestsPagination: {
      current: null,
      total: null,
      data: [],
    },
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
      state.loading = false;
    },
    SET_LOADING: (state, value) => {
      state.loading = value;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
      state.loading = false;
    },
    SET_REQUESTS_PAGINATION: (state, data) => {
      state.requestsPagination = data;
      state.loading = false;
    },
  },
  actions: {
    get: function ({ commit, dispatch, state }, payload = {}) {
      let url = `vendors/networks/${payload.id}/view`;
      if (payload.limit) {
        url = `${url}?limit=${payload.limit}`;
      }
      if (payload.page) {
        url = `${url}&page=${payload.page}`;
      }

      if (!payload.page) {
        commit("SET_LOADING", true);
      }

      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              }
              commit("SET_LOADING", false);
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            commit("SET_LOADING", false);
            return resolve();
          });
      });
    },
    getRequests: function ({ commit, dispatch, state }, payload = {}) {
      let url = `vendors/networks/${payload.id}/view-requests`;
      if (payload.limit) {
        url = `${url}?limit=${payload.limit}`;
      }
      if (payload.status) {
        url = `${url}&status=${payload.status}`;
      }
      if (payload.page) {
        url = `${url}&page=${payload.page}`;
      }

      if (!payload.page) {
        commit("SET_LOADING", true);
      }

      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload.page) {
                commit("SET_REQUESTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload.limit) {
                commit("SET_REQUESTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              }
              commit("SET_LOADING", false);
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            commit("SET_LOADING", false);
            return resolve();
          });
      });
    },
    addVendorToNetwork: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`vendors/networks/add`, payload)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    removeVendorFromNetwork: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`vendors/networks/${payload.vendor_1}/${payload.vendor_2}`)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    changeNetworkStatus: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .put(`vendors/networks/${payload.id}`, { status: payload.status })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
  },
};
